// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"122":"a7b96b25","413":"87eda396"}[chunkId] + ".chunk.js");